import React from "react";
import {HtmlDisplay} from "../Display";
import {GridCell} from "../Grid";
import {HelpText} from "./HelpText";
import {Notification} from "./Notification";
import {notificationSuffix, helpTextSuffix} from "./inputConstants";

export interface FieldsetLayoutProps {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    hasMultipleInputs?: boolean;
    helpText?: string;
    isInline?: boolean;
    legend?: string;
    legendClass?: string;
    name: string;
    error?: string;
    responseFeedback?: string;
    listHasTextField?: string[];
}

export const FieldsetLayout: React.FC<FieldsetLayoutProps> = ({
                                   children,
                                   className="",
                                   disabled,
                                   hasMultipleInputs,
                                   helpText,
                                   isInline,
                                   legend,
                                   legendClass,
                                   name,
                                   error,
                                   responseFeedback,
                               }: FieldsetLayoutProps) => {

    const setClasses = `${isInline ? "fieldset--inline" : ""} ${className}`;
    const legendClasses = `${hasMultipleInputs ? "" : "label"} ${legendClass}`;

    return (
        <GridCell>
            <fieldset
                className={setClasses}
                disabled={disabled}
                aria-invalid={!!error}
                aria-errormessage={`${name}${notificationSuffix}`}
                aria-describedby={`${name}${helpTextSuffix}`}
            >
                <legend className={legendClasses}>
                    <HtmlDisplay html={legend} isInline/>
                </legend>
                {children}
            </fieldset>
            <HelpText name={name} helpText={helpText} responseFeedback={responseFeedback}/>
            <Notification error={error} name={name} label={legend}/>
        </GridCell>
    );
};
